import Axios from 'axios'
import { debounce } from 'lodash'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Link, useNavigate} from "react-router-dom"
import { SEARCHPRODUCT, X_TENANT_ID } from './ActionUrl'
import { _useToasts } from './_useToasts'
import { productPath } from '../util/helper'
import { useThemeSettings } from '../layouts/state/useThemeSettings'
import { AuthContext } from './Auth'

const SearchBar = (props) => {
    const { execute, theme, mainTheme } = props
    const { _addToast } = _useToasts()
    const { settingData , user} = useContext(AuthContext)
    const searchRef = useRef()
    const navigate = useNavigate()
    const lastData = useRef(props);
    const isInitialRender = useRef(true);
    const [inputValue, setInputValue] = useState("");
    const [inputValue2, setInputValue2] = useState("");
    const [productNameList, setProductNameList] = useState([])
    const [productCatList, setProductCatList] = useState([])
    const [productTagList, setproductTagList] = useState([])
    const [productColorList, setproductColorList] = useState([])
    const [productSizeList, setproductSizeList] = useState([])
    const [visible, setVisible] = useState(false);
    const userId = user?.userId

    const {
        itemNumber,
    } = useThemeSettings({ settingData });

    useEffect(() => {
        if (typeof window !== undefined) {
            window.addEventListener("mouseup", (e) => {
                if (visible && !searchRef?.current?.contains(e.target)) {
                    setVisible(false);
                }
            });
        }
    }, [visible]);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            navigate(process.env.PUBLIC_URL + `/products/?q=${inputValue2}`)
        }
    }
    useEffect(() => {
        if (inputValue) {
            getProducts(inputValue)
            setVisible(true)
        } else {
            setProductNameList([])
            setProductCatList([])
            setproductTagList([])
            setproductColorList([])
            setproductSizeList([])
        }
    }, [inputValue])

    const getProducts = (searchValue = "") => {
        const requestOptions = {
            headers: { 'X-TENANT-ID': X_TENANT_ID },
        }
        if (searchValue !== "" && searchValue !== "undefined" && searchValue !== undefined) {
            let url = SEARCHPRODUCT + `?productName=${searchValue}&user=${ userId ?? '' }`
            Axios.get(url, requestOptions)
                .then(async res => {
                    if (res.data.error) {
                        _addToast(res.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        })
                    } else {
                        setProductNameList(res.data.products)
                        setProductCatList(res.data.categories)
                        setproductTagList(res.data.tags)
                        setproductColorList(res.data.colors)
                        setproductSizeList(res.data.sizes)
                    }
                })
                .catch(err => {
                    console.log('err', err)
                })
        } else {
            setProductNameList([])
            setProductCatList([])
            setproductTagList([])
            setproductColorList([])
            setproductSizeList([])
        }
    }
    useEffect(() => {
        if (execute) {
            if (isInitialRender.current) {
                isInitialRender.current = false;
                return;
            }
            if (JSON.stringify(lastData.current) === JSON.stringify(props)) {
                return;
            }
            lastData.current = props;
            getProducts()
            setVisible(true)
        }
        return () => {
            debouncedChangeHandler.cancel()
        }
    }, [props])
    const debouncedChangeHandler = useMemo(
        () => debounce((newValue) => setInputValue(newValue), 300),
        []
    );
    const handleInputChange = (event) => {
        const newValue = event.target.value;
        setInputValue2(newValue);
        debouncedChangeHandler(newValue);
    }
    const goToTagProduct = (e, tag) => {
        const params = new URLSearchParams()
        setVisible(false)
        params.append("tags", tag._id)
        navigate({ pathname: '/products', search: params.toString() })
    }
    const goToProduct = (e, product) => {
        localStorage.removeItem('catTree')
        setVisible(false)
        navigate(process.env.PUBLIC_URL + "/product/" + productPath(product))
    }
    const goToCatProduct = (e, category) => {
        const params = new URLSearchParams()
        setVisible(false)
        params.append("cat", category._id)
        navigate({ pathname: '/products', search: params.toString() })
    }
    const goToColorProduct = (e, color)=>{
        const params = new URLSearchParams()
        setVisible(false)
        params.append("colors", color)
        navigate({  pathname: '/products', search: params.toString() })
    }
    const goToSizeProduct = (e, size)=>{
        const params = new URLSearchParams()
        setVisible(false)
        params.append("sizes", size.size)
        navigate({  pathname: '/products', search: params.toString() })
    }
    return (
        <div className={`searchRow ${theme === 'apparel' ? 'apparelTheme pb-5' : ''} ${mainTheme === 'dark' ? 'dark-search' : ''}`} ref={searchRef}>
            <div className={`container-fluid ${theme === 'beach' || theme === 'apparel' ? 'beachTheme' : ''}`}>
                <div className="search-form">
                    <form>
                        <div className="input-row">
                            <input type="text" placeholder="Search Product" onChange={handleInputChange} onKeyDown={handleKeyDown} className={`${mainTheme === 'dark' ? 'dark-search' : ''}`}/>
                            {
                                inputValue ?
                                    <Link className="button-search searchbtn"
                                        to={process.env.PUBLIC_URL + `/products/?q=${inputValue}`}>
                                        <i className="pe-7s-search" title="Search" />
                                    </Link> :
                                    <button
                                        className="searchbtn"
                                        onClick={(event) => {
                                            event.preventDefault()
                                        }}
                                    >
                                        <i className="pe-7s-search" title="Search" />
                                    </button>
                            }
                        </div>
                    </form>
                    {visible ?
                        <div className={`searchList ${mainTheme === 'dark' ? 'dark-search' : ''}`}>
                            {productNameList.length > 0 && (
                                <>
                                    <div className="w-100 m-0">
                                        <h4 className="f-w-600 pl-1">Products</h4>
                                        <ul>
                                            {productNameList.map((data, index) => (
                                                <li
                                                    className="ml-3"
                                                    key={data.id}
                                                    onClick={(event) => {
                                                        event.preventDefault()
                                                        goToProduct(event, data)
                                                    }}
                                                >
                                                    {data[itemNumber]} - {data.productName}
                                                </li>
                                            ))}
                                        </ul>
                                        {productNameList && productNameList.length >= 5 &&
                                            <div className="view-all"><Link to={process.env.PUBLIC_URL + `/products/?q=${inputValue}`}>View all products</Link></div>
                                        }
                                    </div>
                                </>
                            )}

                            {productCatList.length > 0 && (
                                <>
                                    <div className="w-100 m-0">
                                        <h4 className="f-w-600 pl-1">Categories</h4>
                                        <ul>
                                            {productCatList.map((data, index) => (
                                                <li
                                                    className="ml-3"
                                                    key={data.id}
                                                    onClick={(event) => {
                                                        event.preventDefault()
                                                        goToCatProduct(event, data)
                                                    }}
                                                >
                                                    {data.categoryName}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </>
                            )}
                            {productTagList.length > 0 && (
                                <>
                                    <div className="w-100 m-0">
                                        <h4 className="f-w-600 pl-1">Tags</h4>
                                        <ul>
                                            {productTagList.map((data, index) => (
                                                <li
                                                    className="ml-3"
                                                    key={data.id}
                                                    onClick={(event) => {
                                                        event.preventDefault()
                                                        goToTagProduct(event, data)
                                                    }}
                                                >
                                                    {data.tagName}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </>
                            )}
                            {productColorList.length > 0 && (
                          <>
                            <div className="w-100 m-0">
                              <h4 className="f-w-600 pl-1">Colors</h4>
                              <ul>
                                {productColorList.map((data, index) => (
                                  <li
                                    className="ml-3"
                                    key={data.id}
                                    onClick={(event) => {
                                      event.preventDefault()
                                      goToColorProduct(event, data)
                                    }}
                                  >
                                    {data}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </>
                        )}
                        {productSizeList.length > 0 && (
                          <>
                            <div className="w-100 m-0">
                              <h4 className="f-w-600 pl-1">Sizes</h4>
                              <ul>
                                {productSizeList.map((data, index) => (
                                  <li
                                    className="ml-3"
                                    key={data.id}
                                    onClick={(event) => {
                                      event.preventDefault()
                                      goToSizeProduct(event, data)
                                    }}
                                  >
                                    {data.size}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </>
                        )}
                        </div> : ''}
                </div>
            </div>
        </div>
    )
}
export default SearchBar
